export default __webpack_public_path__ + "static/media/ISKO_CLASS-1_SYLLABUS.57ce7b4d.pdf";